import { getHotelAnalyticsName, addEventToDataLayer } from '../utils/Analytics';

const getCurrencyAmount = (cart, currencyCode) => {
  try {
    return cart.amount[currencyCode];
  } catch (e) {
    return 0;
  }
};

const bookingCreatedEvent = (state, formData, locator, lang, isPending) => {
  const { cartHotel } = state.cart;
  const { utmParams } = state.bookingFormState;
  const hotelName = getHotelAnalyticsName(cartHotel);
  const currencyCode = cartHotel.currency.code;

  const products = cartHotel.rooms.map((room) => ({
    category: hotelName,
    uid: cartHotel.code,
    name: `${hotelName} | ${room.room.name}`,
    id: room.room.code,
    price: room.amount[currencyCode].toFixed(2) / room.nights,
    list: 'habitaciones',
    variant: '',
    quantity: room.nights,
    coupon: '',
  }));

  const totalAmount = getCurrencyAmount(state.cart, currencyCode);
  return {
    event: 'purchase',
    utmSource: utmParams ? utmParams.utm_source : undefined,
    hotelName,
    status: isPending ? 'pending' : 'confirmed',
    fechaDeInicio: cartHotel.rooms[0].checkIn,
    fechaDeSalida: cartHotel.rooms[0].checkOut,
    languageCode: lang,
    transactionPayment: '',
    eurAmount: getCurrencyAmount(state.cart, 'EUR'),
    usdAmount: getCurrencyAmount(state.cart, 'USD'),
    ecommerce: {
      purchase: {
        actionField: {
          id: locator,
          status: isPending ? 'pending' : 'confirmed',
          affiliation: formData.cli_code,
          email: formData.cli_email,
          promocode: cartHotel.rooms[0].board.promocode_applied,
          revenue: totalAmount,
          tax: 0,
          shipping: 0,
          codeCurrency: currencyCode,
          coupon: '',
          totalRooms: cartHotel.rooms.length,
        },
        products,
      },
    },
  };
};

const paymentCreatedEvent = (booking) => ({
  event: 'payment',
  paymentGateway: booking.payment_external_method,
  locator: booking.locator,
});

const bookingCancelledEvent = (booking, cancelStatus) => {
  const hotelName = getHotelAnalyticsName(booking.hotel);
  return {
    event: 'refund',
    hotelCode: booking.hotel.code,
    hotelName,
    cancellationFee: booking.cancellation_fee,
    status: booking.status,
    cancelStatus,
    ecommerce: {
      refund: {
        actionField: {
          transaction_id: booking.locator,
          affiliation: booking.cli_code,
          email: booking.cli_email,
          revenue: -booking.amount.toFixed(2), // Booking total
          codeCurrency: booking.currency.code,
        },
      },
    },
  };
};

const addRoomToCartEvents = ({
  cart, lang, userCurrency, utmSource,
}) => {
  const hotel = cart.cartHotel;
  if (hotel.isEmpty) {
    return [];
  }
  const hotelName = getHotelAnalyticsName(hotel);
  return hotel.rooms.map((room, idx) => {
    const userAmount = room.amount[userCurrency.code] || 0;
    const roomData = room.room;
    return {
      utmSource,
      event: 'add_to_cart',
      hotelName,
      nombreHotel: hotelName,
      languageCode: lang,
      tipoHabitacionl: roomData.name,
      cuartosNoche: room.nights,
      fechaDeInicio: room.checkIn,
      fechaDeSalida: room.checkOut,
      rateCode: room.rate.code,
      boardCode: room.board.code,
      numAdults: room.use.adults || 2,
      numChildren: room.use.childs || 0,
      numRoom: idx + 1,
      childrenAges: room.use.ages ? room.use.ages.join(',') : '',
      userCurrencyCode: userCurrency.code,
      userPrice: userAmount.toFixed(2),
      ecommerce: {
        currencyCode: hotel.currency.code,
        add: {
          products: [{
            id: roomData.code,
            category: hotelName,
            name: `${hotelName} | ${roomData.name}`,
            price: room.amount[hotel.currency.code].toFixed(2),
            variant: '',
            quantity: room.nights,
          }],
        },
      },
    };
  });
};

const clearCartEvent = ({
  cart, lang, userCurrency,
}) => {
  // The message takes the previous cart status
  const hotel = cart.cartHotel;
  if (hotel.isEmpty) {
    return [];
  }
  const hotelName = getHotelAnalyticsName(hotel);
  return hotel.rooms.map((room) => ({
    event: 'emptyCart',
    hotelName,
    nombreHotel: hotelName,
    languageCode: lang,
    tipoHabitacionl: room.room.name,
    cuartosNoche: room.nights,
    fechaDeInicio: room.checkIn,
    fechaDeSalida: room.checkOut,
    rateCode: room.rate.code,
    boardCode: room.board.code,
    numAdults: room.use.adults || 2,
    numChildren: room.use.childs || 0,
    childrenAges: room.use.ages ? room.use.ages.join(',') : '',
    userCurrencyCode: userCurrency.code,
    userPrice: 0, // The cart is entirely cleared
    ecommerce: {
      currencyCode: hotel.currency.code,
      remove: {
        products: [],
      },
    },
  }));
};

const sendSimpleGAEvent = (typeOfAction, fieldName) => {
  const gaEvent = {
    event: typeOfAction,
    eventAction: typeOfAction,
    eventLabel: [fieldName],
  };
  addEventToDataLayer(gaEvent);
};

export {
  addRoomToCartEvents,
  bookingCreatedEvent,
  bookingCancelledEvent,
  paymentCreatedEvent,
  clearCartEvent,
  sendSimpleGAEvent,
};
